module.exports = __webpack_public_path__ + "static/191016-BS-IGB-Lobby-Blade-n-Ghoul-RNG-c6a10a677849e2d67317bc905e53f1d6.jpg";